import { render } from "./ResultadoCotizacion.vue?vue&type=template&id=73049578&scoped=true"
import script from "./ResultadoCotizacion.vue?vue&type=script&lang=js"
export * from "./ResultadoCotizacion.vue?vue&type=script&lang=js"

import "./ResultadoCotizacion.vue?vue&type=style&index=0&id=73049578&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73049578"]])

export default __exports__